/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdvancedCreateAndEditWithSubTabTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2V2zm2 2v12h16V4H4zm16 14H4v2h16v-2zm-7-9H6V7h7v2zm5 0h-3V7h3v2zm-9 4H6v-2h3v2zm9 0h-7v-2h7v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAdvancedCreateAndEditWithSubTabTemplate as AdvancedCreateAndEditWithSubTabTemplate };
